import { IconWrapper } from '@/components/shared/IconWrapper';
import { Button, Span } from '@chakra-ui/react';

import { useTranslation } from 'react-i18next';
import { Plus } from 'iconoir-react';

interface AddNewPaymentMethodButtonProps {
  onClick: () => void;
}

export const AddNewPaymentMethodButton: React.FC<AddNewPaymentMethodButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      colorPalette="primary"
      borderStyle="dashed"
      borderWidth="1.5px"
      borderColor="gray.300"
      justifyContent="flex-start"
      rounded="lg"
      _hover={{
        bg: 'primary.50',
        borderColor: 'primary.300',
      }}
      onClick={onClick}
      w="full"
      px={3}
      py={0}
      h="50px"
    >
      <IconWrapper
        icon={Plus}
        gradientFrom="primary.200"
        gradientTo="primary.50"
        boxSize={4}
        mr={3} // Keep the margin
      />
      <Span color="gray.950" fontWeight="medium">
        {t('payouts.checkout.paymentMethodModal.addNewButton')}
      </Span>
    </Button>
  );
};
